import Chartist from "chartist";
import $ from "jquery";

/**
 * Misc chart related helpers.
 */
const chart = {
  /**
   * TODO: something that doesn't use SMIL
   * and something that's not literally the example:)
   *
   * https://gionkunz.github.io/chartist-js/examples.html
   * @param  {object} data
   */
  animatePieChart(data) {
    if (data.type === "slice") {
      // Get the total path length in order to use for dash array animation
      const pathLength = data.element._node.getTotalLength();

      // Set a dasharray that matches the path length as prerequisite to animate dashoffset
      data.element.attr({
        "stroke-dasharray": `${pathLength}px ${pathLength}px`,
      });

      // Create animation definition while also assigning an ID to the animation for later sync usage
      const animationDefinition = {
        "stroke-dashoffset": {
          id: `anim${data.index}`,
          dur: 500,
          from: `${-pathLength}px`,
          to: "0px",
          easing: Chartist.Svg.Easing.easeInOutSine,
          // We need to use `fill: 'freeze'` otherwise our animation will fall back to initial (not visible)
          fill: "freeze",
        },
      };

      // If this was not the first slice, we need to time the animation so that it uses the end sync event of the previous animation
      if (data.index !== 0) {
        animationDefinition["stroke-dashoffset"].begin = `anim${
          data.index - 1
        }.end`;
      }

      // We need to set an initial value before the animation starts as we are not in guided mode which would do that for us
      data.element.attr({
        "stroke-dashoffset": `${-pathLength}px`,
      });

      // We can't use guided mode as the animations need to rely on setting begin manually
      // See http://gionkunz.github.io/chartist-js/api-documentation.html#chartistsvg-function-animate
      data.element.animate(animationDefinition, false);
    }
  },

  /**
   * Render pie chart
   *
   * @param {object} data {series:[...], labels:[...]};
   * @param {string} selector to use as chart target.
   */
  renderPieChart(data, selector) {
    const pieChart = new Chartist.Pie(
      selector,
      {
        series: data.series,
        labels: data.labels,
      },
      {
        donut: true,
        donutWidth: 10,
        chartPadding: 30,
        total: _.reduce(data.series, (total, percent) => total + percent),
        labelOffset: 20,
        labelDirection: "explode",
      }
    );

    pieChart.on("draw", this.animatePieChart);
  },

  /**
   * Init this module.
   */
  init() {
    const self = this;
    $(".pie-chart-target").each(function () {
      const $this = $(this);
      const id = $this.prop("id");
      const $chartConfig = $(`[data-chart-target="${id}"]`);
      if ($chartConfig.length) {
        self.renderPieChart($.parseJSON($chartConfig.val()), `#${id}`);
      }
    });
  },
};

export default chart;
